module.exports = "https://static.energy5.com/_next/static/images/evCharging-ee4aa325be88a73489b490f6ec261aca.webp";